import React from 'react'

import Loading from './Loading'
import { fadeIn } from '../../animations'

class Img extends React.Component {
  componentDidMount() {
    fadeIn(this.img)
  }

  render() {
    return (
      <img
        ref={el => {
          this.img = el
        }}
        style={{ opacity: 0 }}
        {...this.props}
      />
    )
  }
}

export default class Image extends React.Component {
  state = { imageLoaded: false }
  fetchImage = this.fetchImage.bind(this)
  imageLoaded = this.imageLoaded.bind(this)
  _mounted = false

  componentWillMount() {
    this.fetchImage()
  }
  componentDidMount() {
    this._mounted = true
  }
  componentWillUnmount() {
    this._mounted = false
  }
  fetchImage() {
    if (typeof document !== 'undefined') {
      const img = document.createElement('img')
      img.src = this.props.src
      img.addEventListener('load', this.imageLoaded)
    }
  }
  imageLoaded() {
    if (this._mounted) this.setState({ imageLoaded: true })
  }
  render() {
    const { imageLoaded } = this.state

    return (
      <div>
        {imageLoaded ? <Img {...this.props} /> : <Loading color="#ff486a" percentHeight={66.6} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/Image.js